import {
  initialQuestionnaireState,
  RESET_QUESTIONNAIRE,
  UPDATE_PAGE_INDEX,
  UPDATE_QUESTIONNAIRE,
  UPDATE_QUESTIONNAIRE_FLOWTYPE,
} from './constants'

export const questionnaireReducer = (
  state: QuestionnaireState = initialQuestionnaireState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): QuestionnaireState => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case UPDATE_QUESTIONNAIRE:
      return {
        ...state,
        ...actionPayload,
      }
    case UPDATE_QUESTIONNAIRE_FLOWTYPE:
      return {
        ...state,
        questionnaireFlowType: actionPayload,
      }
    case UPDATE_PAGE_INDEX:
      return {
        ...state,
        activePageIndex: actionPayload,
      }
    case RESET_QUESTIONNAIRE:
      return initialQuestionnaireState
    default:
      return state
  }
}
